'use client';

import { createContext, use, useContext } from 'react';

const SiteSettingsContext = createContext(null);
const EMPTY = { settings: {}, campaign: {} };

export const SiteSettingsProvider = ({ settingsPromise, children }) => (
  <SiteSettingsContext.Provider value={settingsPromise}>
    {children}
  </SiteSettingsContext.Provider>
);

export function useSiteSettingsPromise() {
  const settingsPromise = useContext(SiteSettingsContext);
  if (!settingsPromise) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return settingsPromise;
}

export const useSiteSettings = () => use(useSiteSettingsPromise()) ?? EMPTY;
